import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import StudentDetails from "./StudentDetails";
import AdmDesignComponent from "./FeeDetails";
import AdmPersonalDetails from "./AddressDetails";
import GuardianDetails from "./GuardianDetails";
import AdmOtherDetails from "./SiblingDetails";
import EmergencyContact from "./EmergencyContact";
import AuthorisedPickUp from "./AuthorisedPickUp";
import DocumentsSubmitted from "./DocumentsSubmitted";
import PreviousEducationDetails from "./PreviousEducationDetails";
import { ApiUrl } from "../../../ApiUrl";
import { MAX_REGISTRATION_UPLOAD_BYTES } from "../../utils/uploadUtils";
// function CustomTabPanel(props) {
//   const { children, value, index, ...other } = props;
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      hidden={value !== index}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function BasicTabs() {
  const { id } = useParams();
  const [isDataLoading, setIsDataLoading] = useState(true);

  const [value, setValue] = React.useState(0);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [requiredFieldsAlert, setRequiredFieldsAlert] = useState({
    isOpen: false,
    fields: [],
    actionText: "saving",
  });
  const maxTabIndex = isEditMode ? 7 : 8;
  const [isTransportAvailed, setIsTransportAvailed] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState({});
  const [selectedRoute, setSelectedRoute] = useState("");
  const [selectedPickUpPoint, setSelectedPickUpPoint] = useState("");
  const [frontCover, setFrontCover] = useState(null);
  const fileInputRef = React.useRef(null);

  const [formData, setFormData] = React.useState({
    academic_year: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    addmitted_class: "",
    addmitted_section: "",
    gender: "",
    date_of_admission: "",
    dob: "",
    doj: "",
    father_name: "",
    mother_name: "",
    studentaadharno: "",
    email: "",
    registration_no: "",
    school_admission_no: "",
    cbse_reg_no: "",
    house: "",
    religion: "",
    category: "",
    nativelanguage: "",
    bloodgroup: "",
    nationality: "",
    childreninfamily: "",
    studentaadharno: "",
    username: "",
    remarks: "",
    profile_pic: "",
    father_aadharno: "",
    mother_aadharno: "",
    barcode: "",
    father_name: "",
    mother_name: "",
    fatherTitle: "",
    motherTitle: "",
    father_profession: "",
    mother_profession: "",
    father_contact_number: "",
    mother_contact_number: "",
    father_email: "",
    mother_email: "",
    rollno: "",
    student_status: "",
    primary_guardian: "",
    feeappfrom: "",
    feegroup: "",
    transport_availed: false,
    route_id: "",
    route_details: "",
    choice_month: [],
    present_address: "",
    present_city: "",
    present_state: "",
    present_country: "",
    present_pincode: "",
    present_phone_number: "",
    permanent_address: "",
    permanent_city: "",
    permanent_state: "",
    permanent_country: "",
    permanent_pincode: "",
    permanent_phone_number: "",
    sibilingsDetails: [],
    emegencyContact: [],
    authorizedpickup: [],
    documentsDetails: [],
    previousEducationDetails: [],
  });

  const numberOfTabs = 9;
  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // const handleNext = () => {
  //   setValue((prevValue) => Math.min(prevValue + 1, numberOfTabs - 1));
  // };
  const handleNext = () => {
    setValue((prevValue) => Math.min(prevValue + 1, maxTabIndex));
  };

  const handlePrevious = () => {
    setValue((prevValue) => Math.max(prevValue - 1, 0));
  };
  const handleNewClick = () => {
    navigate("/admin/registration");
  };

  useEffect(() => {
    const clearSessionOnRefresh = () => {
      sessionStorage.removeItem("profile_pic_base64");
      sessionStorage.removeItem("profile_pic_name");
      sessionStorage.removeItem("profile_pic_type");
    };

    window.addEventListener("beforeunload", clearSessionOnRefresh);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("beforeunload", clearSessionOnRefresh);
    };
  }, []);

  //08192025
  const handleClearForm = () => {
    setFormData({
      academic_year: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      addmitted_class: "",
      addmitted_section: "",
      gender: "",
      date_of_admission: "",
      dob: "",
      doj: "",
      father_name: "",
      mother_name: "",
      studentaadharno: "",
      email: "",
      registration_no: "",
      school_admission_no: "",
      cbse_reg_no: "",
      house: "",
      religion: "",
      category: "",
      nativelanguage: "",
      bloodgroup: "",
      nationality: "",
      childreninfamily: "",
      username: "",
      remarks: "",
      profile_pic: "",
      profile_pic_preview: "", // ✅ clear preview
      father_aadharno: "",
      mother_aadharno: "",
      barcode: "",
      fatherTitle: "",
      motherTitle: "",
      father_profession: "",
      mother_profession: "",
      father_contact_number: "",
      mother_contact_number: "",
      father_email: "",
      mother_email: "",
      rollno: "",
      student_status: "",
      primary_guardian: "",
      feeappfrom: "",
      feegroup: "",
      transport_availed: false, // ✅ reset properly
      route_id: "",
      route_details: "",
      choice_month: [],
      present_address: "",
      present_city: "",
      present_state: "",
      present_country: "",
      present_pincode: "",
      present_phone_number: "",
      permanent_address: "",
      permanent_city: "",
      permanent_state: "",
      permanent_country: "",
      permanent_pincode: "",
      permanent_phone_number: "",
      sibilingsDetails: [],
      // emegencyContact: [],
      // authorizedpickup: [],
      emegencyContact: [
        { name: "", relationship: "", Mobile_Number: "", remark: "" },
      ],
      authorizedpickup: [
        { name: "", relationship: "", Mobile_Number: "", remark: "" },
      ],
      documentsDetails: [],
      previousEducationDetails: [],
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // ✅ clears file name
    }

    setIsTransportAvailed(false);
    setSelectedMonths({});
    setSelectedRoute("");
    setSelectedPickUpPoint("");
    setFrontCover(null); // ✅ clear profile image preview

    // Clear localStorage/sessionStorage flags
    localStorage.removeItem("selectedClassId");
    localStorage.removeItem("selectedCategoryId");
    sessionStorage.setItem("ClassLogic", "false");
    sessionStorage.setItem("CategoryLogic", "false");
  };

  const formatToISODate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString();
  };

  const getRequiredFieldsConfig = (isSaveMode = false) => {
    const requiredFields = [
      { key: "first_name", label: "First Name" },
      { key: "last_name", label: "Last Name" },
      { key: "addmitted_class", label: "Admitted Class" },
      { key: "addmitted_section", label: "Admitted Section" },
      { key: "gender", label: "Gender" },
      { key: "date_of_admission", label: "Date Of Admission" },
      { key: "doj", label: "Date Of Join" },
      { key: "house", label: "House" },
      { key: "religion", label: "Religion" },
      { key: "category", label: "Category" },
      { key: "nationality", label: "Nationality" },
      { key: "dob", label: "Date Of Birth" },
      { key: "father_name", label: "Father Name" },
      { key: "father_profession", label: "Father Profession" },
      { key: "father_contact_number", label: "Father Contact Number" },
      { key: "mother_name", label: "Mother Name" },
      { key: "mother_profession", label: "Mother Profession" },
      { key: "mother_contact_number", label: "Mother Contact Number" },
      { key: "present_address", label: "Present Address" },
      { key: "present_pincode", label: "Present Pincode" },
      { key: "present_district", label: "Present District" },
      { key: "present_state", label: "Present State" },
      { key: "present_country", label: "Present Country" },
      { key: "present_phone_number", label: "Present Phone Number" },
      { key: "permanent_address", label: "Permanent Address" },
      { key: "permanent_pincode", label: "Permanent Pincode" },
      { key: "permanent_district", label: "Permanent District" },
      { key: "permanent_state", label: "Permanent State" },
      { key: "permanent_country", label: "Permanent Country" },
      { key: "permanent_phone_number", label: "Permanent Phone Number" },
    ];

    if (isSaveMode) {
      requiredFields.push(
        { key: "feegroup", label: "Fee Group" },
        { key: "feeappfrom", label: "Fee Applied From" }
      );
    }

    return requiredFields;
  };

  const getMissingRequiredFields = (data, isSaveMode = false) => {
    const requiredFields = getRequiredFieldsConfig(isSaveMode);
    return requiredFields
      .filter((field) => {
        const value = data[field.key];
        return (
          value === undefined ||
          value === null ||
          (typeof value === "string" && value.trim() === "")
        );
      })
      .map((field) => field.label);
  };

  const getMissingRequiredField = (data, isSaveMode = false) => {
    const missingFields = getMissingRequiredFields(data, isSaveMode);
    return missingFields.length ? missingFields[0] : null;
  };

  const showRequiredFieldsAlert = (fields, actionText = "saving") => {
    setRequiredFieldsAlert({
      isOpen: true,
      fields,
      actionText,
    });
  };

  const closeRequiredFieldsAlert = () => {
    setRequiredFieldsAlert((prev) => ({ ...prev, isOpen: false }));
  };

  const getFirstErrorMessage = (errorObj, prefix = "") => {
    if (typeof errorObj === "string") {
      return prefix ? `${prefix}: ${errorObj}` : errorObj;
    }

    if (Array.isArray(errorObj)) {
      if (errorObj.length === 0) return "";
      return getFirstErrorMessage(errorObj[0], prefix);
    }

    if (errorObj && typeof errorObj === "object") {
      const keys = Object.keys(errorObj);
      if (keys.length === 0) return "";
      const key = keys[0];
      const nextPrefix = prefix ? `${prefix}.${key}` : key;
      return getFirstErrorMessage(errorObj[key], nextPrefix);
    }

    return "";
  };

  const getApiErrorMessage = (result, fallbackMessage) => {
    const source = result?.message ?? result?.error ?? result;
    const parsed = getFirstErrorMessage(source);
    return parsed || fallbackMessage;
  };

  const mapLegacyRequiredMessage = (message, data, isSaveMode = false) => {
    const normalized = (message || "").toLowerCase();

    if (normalized.includes("studentbasicdetails required")) {
      const missingField = getMissingRequiredField(data, isSaveMode);
      return missingField
        ? `${missingField} is required.`
        : "A required student field is missing.";
    }

    if (normalized.includes("addressdetails required")) {
      const addressFields = [
        { key: "present_address", label: "Present Address" },
        { key: "present_pincode", label: "Present Pincode" },
        { key: "present_district", label: "Present District" },
        { key: "present_state", label: "Present State" },
        { key: "present_country", label: "Present Country" },
        { key: "present_phone_number", label: "Present Phone Number" },
      ];

      for (const field of addressFields) {
        const value = data[field.key];
        if (
          value === undefined ||
          value === null ||
          (typeof value === "string" && value.trim() === "")
        ) {
          return `${field.label} is required.`;
        }
      }

      return "Address details are required.";
    }

    return message;
  };

  useEffect(() => {
    if (id) {
      // ✅ Always set edit mode when id exists
      setIsEditMode(true);

      fetch(
        `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetStudentDetailsBasedOnId/${id}`
      )
        .then((response) => response.json())
        .then(async (data) => {
          if (data.message === "success") {
            const student = data.data.student_basic_details;
            setSelectedStudentId(student?.id || null);
            const addressDetailsRaw =
              data.data.address_details || data.data.addressDetails || [];
            const addressDetails = Array.isArray(addressDetailsRaw)
              ? addressDetailsRaw[0] || {}
              : addressDetailsRaw || {};
            const documentDetailsRaw =
              data.data.documents_details || data.data.documentsDetails || [];
            const educationDetailsRaw =
              data.data.previous_education_details || [];
            const siblingsRaw = data.data.sibilings_details || [];

 const documentsDetails = documentDetailsRaw.map((doc) => ({
  id: doc.id || null,
  document_no: doc.document_no || "",
  document_type: doc.document_type || "",
  document_pic: "",
  preview_url: doc.document_url || doc.document_pic || "",
  start_from: doc.start_from || "",
  end_to: doc.end_to || "",
}));

const previousEducationDetails = educationDetailsRaw
  .filter((edu) => edu.is_active !== false)
  .map((edu) => ({
    id: edu.id || null,
    nameofschool: edu.nameofschool || "",
    location: edu.location || "",
    class_completed: edu.class_completed || "",
    year_from: edu.year_from || "",
    year_to: edu.year_to || "",
    language_of_instruction: edu.language_of_instruction || "",
    transfer_certificate: edu.transfer_certificate || "",
    result: edu.result || "",
    is_active: true,
  }));
            // 👨‍👩‍👦 Prepare siblings
            const sibilingsDetails = siblingsRaw.map((sibling) => ({
              admissionNo: sibling.admission_no || "",
              studentName: `${sibling.first_name || ""} ${
                sibling.middle_name || ""
              } ${sibling.last_name || ""}`.trim(),
              class: sibling.classname || "",
              section: sibling.section || "",
              siblings_id: sibling.id || "",
            }));

            // 🎯 Final form data
            const formattedData = {
              ...formData,
              ...student,
              addmitted_class: student.addmitted_class?.toString() || "",
              addmitted_section: student.addmitted_section?.toString() || "",
              date_of_admission: student.date_of_admission
                ? new Date(student.date_of_admission)
                    .toISOString()
                    .split("T")[0]
                : "",
              dob: student.dob
                ? new Date(student.dob).toISOString().split("T")[0]
                : "",
              present_address: addressDetails.present_address || "",
              present_pincode: addressDetails.present_pincode || "",
              present_district: addressDetails.present_district || "",
              present_state: addressDetails.present_state || "",
              present_country: addressDetails.present_country || "",
              present_phone_number: addressDetails.present_phone_number || "",
              permanent_address: addressDetails.permanent_address || "",
              permanent_pincode: addressDetails.permanent_pincode || "",
              permanent_district: addressDetails.permanent_district || "",
              permanent_state: addressDetails.permanent_state || "",
              permanent_country: addressDetails.permanent_country || "",
              permanent_phone_number: addressDetails.permanent_phone_number || "",
              documentsDetails:
                documentsDetails.length > 0
                  ? documentsDetails
                  : [
                      {
                        document_no: "",
                        document_type: "",
                        document_pic: "",
                        preview_url: "",
                        start_from: "",
                        end_to: "",
                      },
                    ],
              previousEducationDetails:
                previousEducationDetails.length > 0
                  ? previousEducationDetails
                  : [
                      {
                        id: null,
                        nameofschool: "",
                        location: "",
                        class_completed: "",
                        year_from: "",
                        year_to: "",
                        language_of_instruction: "",
                        transfer_certificate: "",
                        result: "",
                        is_active: true,
                      },
                    ],
              sibilingsDetails:
                sibilingsDetails.length > 0 ? sibilingsDetails : [],
            };

            setFormData(formattedData);
          } else {
            setErrors({ api: "Failed to fetch data" });
          }
          setIsDataLoading(false);
        })
        .catch((error) => {
          setErrors({ api: error.message });
          setIsDataLoading(false);
        });
    } else {
      setIsEditMode(false); // ✅ only false if id doesn't exist
    }
  }, [id]);
  const isClassOneAdmission = () => {
    const admittedClass = Number(formData.addmitted_class);
    const selectedClassName = String(
      formData.classname || formData.className || ""
    )
      .trim()
      .toLowerCase();

    // Support both numeric class IDs and class names like "Class 1", "1", "I"
    if (admittedClass === 1) {
      return true;
    }

    return /(^class\s*1$)|(^1$)|(^class\s*i$)|(^i$)/i.test(selectedClassName);
  };

  const getPreviousEducationValidationError = () => {
  const today = new Date().toISOString().split("T")[0];

  // Class 1 => Years Attended From/To not required
  if (isClassOneAdmission()) {
    return "";
  }

  const rows = formData.previousEducationDetails || [];

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];

    if (!row.year_from) {
      return `Years Attended From is required in Previous Education row ${i + 1}`;
    }

    if (!row.year_to) {
      return `Years Attended To is required in Previous Education row ${i + 1}`;
    }

    if (row.year_to > today) {
      return `Years Attended To cannot be greater than current date in Previous Education row ${i + 1}`;
    }

    if (row.year_from && row.year_to && row.year_from > row.year_to) {
      return `Years Attended To must be greater than or equal to Years Attended From in Previous Education row ${i + 1}`;
    }
  }

  return "";
};

  const handleSave = async () => {
    const branchId = localStorage.getItem("branchId");
    const orgId = localStorage.getItem("orgId");
    const academicYearFromLocalStorage =
      localStorage.getItem("academicSessionId");
    const userIdFromSession = sessionStorage.getItem("userId");

    const missingFields = getMissingRequiredFields(formData, true);
    if (missingFields.length) {
      showRequiredFieldsAlert(missingFields, "saving");
      return;
    }
    const previousEducationError = getPreviousEducationValidationError();
    if (previousEducationError) {
      showRequiredFieldsAlert([previousEducationError], "saving");
      return;
    }

    const relationshipPattern = /^[A-Za-z\s]+$/;
    const invalidEmergencyRelationship = (formData.emegencyContact || []).find(
      (contact) =>
        contact.relationship && !relationshipPattern.test(contact.relationship.trim())
    );
    if (invalidEmergencyRelationship) {
      alert("Emergency Contact relationship should contain letters only.");
      return;
    }

    const invalidAuthorizedRelationship = (formData.authorizedpickup || []).find(
      (pickup) =>
        pickup.relationship && !relationshipPattern.test(pickup.relationship.trim())
    );
    if (invalidAuthorizedRelationship) {
      alert("Authorised Pickup relationship should contain letters only.");
      return;
    }

    formData.orgId = orgId;
    formData.branchId = branchId;

    const dob = new Date(formData.dob);
    const today = new Date();
    const minDOB = new Date(today.setFullYear(today.getFullYear() - 2));
    if (dob > minDOB) {
      alert("Date of Birth must be at least 2 years prior to today's date.");
      return;
    }

    const studentBasicDetails = {
      academic_year: academicYearFromLocalStorage,
      org_id: orgId,
      branch_id: branchId,
      admission_no: null,
      first_name: formData.first_name,
      middle_name: formData.middle_name || "",
      last_name: formData.last_name,
      addmitted_class: formData.addmitted_class,
      addmitted_section: formData.addmitted_section,
      gender: formData.gender,
      date_of_admission: formatToISODate(formData.date_of_admission),
      doj: formData.doj,
      barcode: formData.barcode || "",
      registration_no: formData.registration_no || "",
      school_admission_no: formData.school_admission_no || null,
      cbse_reg_no: formData.cbse_reg_no || null,
      house: formData.house,
      religion: formData.religion,
      category: formData.category,
      nativelanguage: formData.nativelanguage || "",
      bloodgroup: formData.bloodgroup || "",
      nationality: formData.nationality,
      email: formData.email || "",
      dob: formData.dob,
      childreninfamily: formData.childreninfamily || null,
      studentaadharno: formData.studentaadharno || "",
      username: formData.username || "",
      remarks: formData.remarks || "",
      profile_pic: null,
      father_name: `${formData.fatherTitle} ${formData.father_name}`,
      father_profession: formData.father_profession,
      father_contact_number: formData.father_contact_number,
      father_email: formData.father_email || "",
      father_aadharno: formData.father_aadharno || "",
      mother_name: `${formData.motherTitle} ${formData.mother_name}`,
      mother_profession: formData.mother_profession,
      mother_contact_number: formData.mother_contact_number,
      mother_email: formData.mother_email || "",
      mother_aadharno: formData.mother_aadharno || "",
      created_by: userIdFromSession,
      selected_student_id: selectedStudentId || null,
    };

    const feeDetails = {
      feegroup: parseInt(formData.feegroup),
      feeappform: parseInt(formData.feeappfrom),
    };

    const transportDetails = formData.transport_availed
      ? {
          transportavailed: true,
          choiceMonth: Array.from({ length: 12 }, (_, i) =>
            formData.choice_month?.includes(i + 1) ? i + 1 : null
          ),
          routeId: parseInt(formData.route_id || ""),
          routedetails: parseInt(formData.route_details || ""),
        }
      : null;

    const addressDetails = {
      usertype: "student",
      present_address: formData.present_address || "",
      present_pincode: formData.present_pincode || "",
      present_district: formData.present_district || "",
      present_state: formData.present_state || "",
      present_country: formData.present_country || "",
      present_phone_number: formData.present_phone_number || "",
      permanent_address: formData.permanent_address || "",
      permanent_pincode: formData.permanent_pincode || "",
      permanent_district: formData.permanent_district || "",
      permanent_state: formData.permanent_state || "",
      permanent_country: formData.permanent_country || "",
      permanent_phone_number: formData.permanent_phone_number || "",
    };

    const formPayload = new FormData();
    formPayload.append(
      "studentBasicDetails",
      JSON.stringify(studentBasicDetails)
    );
    formPayload.append("feeDetails", JSON.stringify(feeDetails));
    if (transportDetails) {
      formPayload.append("transportDetails", JSON.stringify(transportDetails));
    }
    formPayload.append("addressDetails", JSON.stringify(addressDetails));

    // formPayload.append(
    //   "sibilingsDetails",
    //   JSON.stringify(
    //     Array.isArray(formData.sibilingsDetails)
    //       ? formData.sibilingsDetails.map((s) => ({ siblings_id: s.siblings_id }))
    //       : []
    //   )
    // );
    formPayload.append(
      "sibilingsDetails",
      JSON.stringify(
        Array.isArray(formData.sibilingsDetails)
          ? formData.sibilingsDetails
              .filter((s) => s.siblings_id) // Only include non-empty IDs
              .map((s) => ({ siblings_id: s.siblings_id }))
          : []
      )
    );

    formPayload.append(
      "emegencyContact",
      JSON.stringify(
        (formData.emegencyContact || []).map((contact) => ({
          name: contact.name,
          relationship: contact.relationship,
          Mobile_Number: contact.Mobile_Number,
          remark: contact.remark,
        }))
      )
    );

    formPayload.append(
      "authorizedpickup",
      JSON.stringify(
        (formData.authorizedpickup || []).map((pickup) => ({
          name: pickup.name,
          relationship: pickup.relationship,
          Mobile_Number: pickup.Mobile_Number,
          remark: pickup.remark,
        }))
      )
    );

    formPayload.append(
      "documentsDetails",
      JSON.stringify(
        (formData.documentsDetails || []).map((doc) => ({
          document_no: doc.document_no,
          document_type: doc.document_type,
          start_from: doc.start_from || null,
          end_to: doc.end_to || null,
        }))
      )
    );

    // formPayload.append(
    //   "previousEducationDetails",
    //   JSON.stringify(
    //     (formData.previousEducationDetails || []).map((edu) => ({
    //       nameofschool: edu.nameofschool,
    //       location: edu.location,
    //       class_completed: edu.class_completed,
    //       year_from: edu.year_from,
    //       year_to: edu.year_to,
    //       language_of_instruction: edu.language_of_instruction,
    //       transfer_certificate: edu.transfer_certificate,
    //       result: edu.result,
    //     }))
    //   )
    // );
    const previousEducationDetails =
      isClassOneAdmission()
        ? []
        : (formData.previousEducationDetails || [])
            .filter(
              (edu) =>
                edu?.nameofschool ||
                edu?.location ||
                edu?.class_completed ||
                edu?.year_from ||
                edu?.year_to ||
                edu?.language_of_instruction ||
                edu?.transfer_certificate ||
                edu?.result
            )
            .map((edu) => ({
              nameofschool: edu.nameofschool,
              location: edu.location,
              class_completed: edu.class_completed,
              year_from: edu.year_from,
              year_to: edu.year_to,
              language_of_instruction: edu.language_of_instruction,
              transfer_certificate: edu.transfer_certificate,
              result: edu.result,
            }));

    formPayload.append(
      "previousEducationDetails",
      JSON.stringify(previousEducationDetails)
    );

    //  Rebuild and attach profile_pic (as binary)
    const base64Data = sessionStorage.getItem("profile_pic_base64");
    const fileName = sessionStorage.getItem("profile_pic_name");
    const fileType = sessionStorage.getItem("profile_pic_type");

    let totalUploadBytes = 0;

    if (base64Data && fileName && fileType) {
      const res = await fetch(base64Data);
      const blob = await res.blob();
      const file = new File([blob], fileName, { type: fileType });
      totalUploadBytes += file.size;
      formPayload.append("profile_pic", file);
    }

    //  Append document files as document_pic[0], document_pic[1], etc.
    (formData.documentsDetails || []).forEach((doc, index) => {
      if (doc.document_pic && typeof doc.document_pic !== "string") {
        totalUploadBytes += doc.document_pic.size || 0;
        formPayload.append(`document_pic[${index}]`, doc.document_pic);
      }
    });

    if (totalUploadBytes > MAX_REGISTRATION_UPLOAD_BYTES) {
      alert(
        "Registration upload is too large. Please use smaller photo or document files and try again."
      );
      return;
    }

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/create/`,
        {
          method: "POST",
          body: formPayload,
        }
      );

      const text = await response.text();
console.log("UPDATE STATUS:", response.status);
console.log("UPDATE RAW TEXT:", text);

let result = {};
try {
  result = text ? JSON.parse(text) : {};
} catch (e) {
  result = { message: text };
}
      if (result.message === "success") {
        alert("Student registration successful!");
        setFormData({});
        sessionStorage.removeItem("profile_pic_base64");
        sessionStorage.removeItem("profile_pic_name");
        sessionStorage.removeItem("profile_pic_type");
        navigate("/admin/registration");
      } else {
        let errorMsg = getApiErrorMessage(
          result,
          "Failed to save. Please check required fields."
        );
        errorMsg = mapLegacyRequiredMessage(errorMsg, formData, true);
        if (/required/i.test(errorMsg)) {
          showRequiredFieldsAlert([errorMsg], "saving");
        } else {
          alert("Registration failed: " + errorMsg);
        }

        // Also log full response for debugging
        console.error("Registration failed response:", result);
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Something went wrong during save.");
    }
  };

  const handleUpdate = async () => {
    const academicYearFromLocalStorage =
      localStorage.getItem("academicSessionId");
    const updatedby = parseInt(sessionStorage.getItem("userId"));
    const selectedClassId = sessionStorage.getItem("selectedClassId");
    const selectedSectionId = sessionStorage.getItem("selectedSectionId");

    const previousEducationError = getPreviousEducationValidationError();
    if (previousEducationError) {
      showRequiredFieldsAlert([previousEducationError], "updating");
      return;
    }

    const missingFields = getMissingRequiredFields(formData, false);
    if (missingFields.length) {
      showRequiredFieldsAlert(missingFields, "updating");
      return;
    }

    const updateStudentId =
      Number(formData?.id) || Number(selectedStudentId) || Number(id);
    if (!updateStudentId) {
      alert("Student record ID is missing. Please reopen this student and try again.");
      return;
    }

    const studentBasicDetails = {
      id: updateStudentId,
      academic_year: academicYearFromLocalStorage,
      admission_no: formData.admission_no,
      first_name: formData.first_name,
      middle_name: formData.middle_name || "",
      last_name: formData.last_name,
      addmitted_class: selectedClassId || formData.addmitted_class,
      addmitted_section: selectedSectionId || formData.addmitted_section,
      gender: formData.gender,
      doj: formData.doj,
      date_of_admission: formatToISODate(formData.date_of_admission),
      dob: formData.dob,
      barcode: formData.barcode || "",
      registration_no: formData.registration_no || "",
      school_admission_no: formData.school_admission_no || null,
      cbse_reg_no: formData.cbse_reg_no || null,
      house: formData.house,
      religion: formData.religion,
      category: formData.category,
      nativelanguage: formData.nativelanguage || "",
      rollno: formData.rollno,
      primary_guardian: formData.primary_guardian,
      student_status: formData.student_status,
      bloodgroup: formData.bloodgroup || "",
      nationality: formData.nationality,
      email: formData.email || "",
      childreninfamily: formData.childreninfamily || null,
      studentaadharno: formData.studentaadharno || "",
      username: formData.username || "",
      remarks: formData.remarks || "",
      profile_pic: null,
      father_name: formData.father_name,
      father_profession: formData.father_profession,
      father_contact_number: formData.father_contact_number,
      father_email: formData.father_email || "",
      father_aadharno: formData.father_aadharno || "",
      mother_name: formData.mother_name,
      mother_profession: formData.mother_profession,
      mother_contact_number: formData.mother_contact_number,
      mother_email: formData.mother_email || "",
      mother_aadharno: formData.mother_aadharno || "",
      is_active: true,
      updated_by: updatedby,
    };

    const addressDetails = {
      present_address: formData.present_address || "",
      present_pincode: formData.present_pincode || "",
      present_district: formData.present_district || "",
      present_state: formData.present_state || "",
      present_country: formData.present_country || "",
      present_phone_number: formData.present_phone_number || "",
      permanent_address: formData.permanent_address || "",
      permanent_pincode: formData.permanent_pincode || "",
      permanent_district: formData.permanent_district || "",
      permanent_state: formData.permanent_state || "",
      permanent_country: formData.permanent_country || "",
      permanent_phone_number: formData.permanent_phone_number || "",
    };

    const sibilingsDetails = Array.isArray(formData.sibilingsDetails)
      ? formData.sibilingsDetails
          .filter((s) => s.siblings_id)
          .map((s) => ({ siblings_id: s.siblings_id }))
      : [];

    const emegencyContact = (formData.emegencyContact || []).map((contact) => ({
      name: contact.name,
      relationship: contact.relationship,
      Mobile_Number: contact.Mobile_Number,
      remark: contact.remark,
    }));

    const authorizedpickup = (formData.authorizedpickup || []).map(
      (pickup) => ({
        name: pickup.name,
        relationship: pickup.relationship,
        Mobile_Number: pickup.Mobile_Number,
        remark: pickup.remark,
      })
    );

    const documentsDetails = (formData.documentsDetails || []).map((doc) => ({
      document_no: doc.document_no,
      document_type: doc.document_type,
      start_from: doc.start_from || null,
      end_to: doc.end_to || null,
    }));

const previousEducationDetails =
  isClassOneAdmission()
    ? []
    : (formData.previousEducationDetails || []).map((edu) => ({
        nameofschool: edu.nameofschool,
        location: edu.location,
        class_completed: edu.class_completed,
        year_from: edu.year_from,
        year_to: edu.year_to,
        language_of_instruction: edu.language_of_instruction,
        transfer_certificate: edu.transfer_certificate,
        result: edu.result,
      }));

    const formPayload = new FormData();
    formPayload.append(
      "studentBasicDetails",
      JSON.stringify(studentBasicDetails)
    );
    formPayload.append("addressDetails", JSON.stringify(addressDetails));
    formPayload.append("sibilingsDetails", JSON.stringify(sibilingsDetails));
    formPayload.append("emegencyContact", JSON.stringify(emegencyContact));
    formPayload.append("authorizedpickup", JSON.stringify(authorizedpickup));
    formPayload.append("documentsDetails", JSON.stringify(documentsDetails));
    formPayload.append(
      "previousEducationDetails",
      JSON.stringify(previousEducationDetails)
    );

    // Attach profile_pic
    if (formData.profile_pic && typeof formData.profile_pic !== "string") {
      formPayload.append("profile_pic", formData.profile_pic);
    } else {
      const base64Data = sessionStorage.getItem("profile_pic_base64");
      const fileName = sessionStorage.getItem("profile_pic_name");
      const fileType = sessionStorage.getItem("profile_pic_type");
      if (base64Data && fileName && fileType) {
        try {
          const res = await fetch(base64Data);
          const blob = await res.blob();
          formPayload.append(
            "profile_pic",
            new File([blob], fileName, { type: fileType })
          );
        } catch (error) {
          console.warn("Error attaching profile_pic from base64:", error);
        }
      }
    }

    // Attach only newly selected document files.
    // Existing document URLs should not be fetched and re-uploaded.
    for (let index = 0; index < (formData.documentsDetails || []).length; index++) {
      const doc = formData.documentsDetails[index];
      if (doc.document_pic && typeof doc.document_pic !== "string") {
        formPayload.append(`document_pic[${index}]`, doc.document_pic);
      }
    }

    // Send API request
const apiUrl = `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/updatestudentrecord/${updateStudentId}/`;
console.log("UPDATE API URL:", apiUrl);
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        body: formPayload,
      });
      const text = await response.text();
console.log("UPDATE STATUS:", response.status);
console.log("UPDATE RAW TEXT:", text);

let result = {};
try {
  result = text ? JSON.parse(text) : {};
} catch (e) {
  result = { message: text };
}

console.log("UPDATE RESULT:", result);
if (response.ok) {
        alert("Student details updated successfully!");
        navigate("/admin/registration");
      } else {
        let errorMsg = getApiErrorMessage(
          result,
          "Failed to update student details."
        );
        errorMsg = mapLegacyRequiredMessage(errorMsg, formData, false);
        if (/required/i.test(errorMsg)) {
          showRequiredFieldsAlert([errorMsg], "updating");
        } else {
          alert("Error: " + errorMsg);
        }
      }
    } catch (error) {
      console.error("Update error:", error);
      alert("Something went wrong during update.");
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <h4
          style={{ textAlign: "center", marginTop: "5px", fontWeight: "700" }}
        >
          STUDENT REGISTRATION{" "}
        </h4>

        <div className="row mt-3 mb-3">
          <div className="col-12 d-flex justify-content-around">
            <button
              type="button"
              className="btn btn-primary"
              style={{
                width: "150px",
              }}
              onClick={handleSave}
              disabled={isEditMode}
            >
              {" "}
              Save{" "}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              style={{
                width: "150px",
              }}
              onClick={handleUpdate}
              disabled={!isEditMode}
            >
              {" "}
              Update{" "}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              style={{
                width: "150px",
              }}
              onClick={handleClearForm}
            >
              {" "}
              Clear{" "}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              style={{
                width: "150px",
              }}
              onClick={handleNewClick}
            >
              {" "}
              Close{" "}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              style={{ width: "150px" }}
              onClick={() => window.location.reload()} // ✅ reload page
            >
              New
            </button>

            <button
              type="button"
              className="btn btn-primary"
              style={{ width: "150px" }}
              onClick={() => window.location.reload()} // ✅ reload page
            >
              Admission Form
            </button>
          </div>
        </div>

        {/* <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Student" {...a11yProps(0)} />
          {!isEditMode && (
            <Tab label="Fee" {...a11yProps(1)} />
          )}
          <Tab label="Address" {...a11yProps(2)} />
          <Tab label="Guardian" {...a11yProps(3)} />
          <Tab label="Sibling" {...a11yProps(4)} />
          <Tab label="Emergency Contact" {...a11yProps(5)} />
          <Tab label="Authorised PickUp" {...a11yProps(6)} />
          <Tab label="Documents Submitted" {...a11yProps(7)} />
          <Tab label="Previous Education " {...a11yProps(8)} />
        </Tabs> */}

        {/* // new code 08182025 */}
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Student" {...a11yProps(0)} />
          {!isEditMode && <Tab label="Fee" {...a11yProps(1)} />}
          <Tab label="Address" {...a11yProps(isEditMode ? 1 : 2)} />
          <Tab label="Guardian" {...a11yProps(isEditMode ? 2 : 3)} />
          <Tab label="Sibling" {...a11yProps(isEditMode ? 3 : 4)} />
          <Tab label="Emergency Contact" {...a11yProps(isEditMode ? 4 : 5)} />
          <Tab label="Authorised PickUp" {...a11yProps(isEditMode ? 5 : 6)} />
          <Tab label="Documents Submitted" {...a11yProps(isEditMode ? 6 : 7)} />
          <Tab label="Previous Education " {...a11yProps(isEditMode ? 7 : 8)} />
        </Tabs>
      </Box>
      {/* <CustomTabPanel value={value} index={0}>
        <StudentDetails
          formData={formData}
          setFormData={setFormData}
          frontCover={frontCover}
          setFrontCover={setFrontCover}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {" "}
        <AdmDesignComponent
          formData={formData}
          setFormData={setFormData}
        />{" "}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AdmPersonalDetails formData={formData} setFormData={setFormData} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        {" "}
        <GuardianDetails formData={formData} setFormData={setFormData} />{" "}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        {" "}
        <AdmOtherDetails formData={formData} setFormData={setFormData} />{" "}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        {" "}
        <EmergencyContact formData={formData} setFormData={setFormData} />{" "}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        {" "}
        <AuthorisedPickUp formData={formData} setFormData={setFormData} />{" "}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={7}>
        {" "}
        <DocumentsSubmitted
          formData={formData}
          setFormData={setFormData}
        />{" "}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={8}>
        {" "}
        <PreviousEducationDetails
          formData={formData}
          setFormData={setFormData}
        />{" "}
      </CustomTabPanel> */}

      {/* // new code 08182025 */}
      <CustomTabPanel value={value} index={0}>
        <StudentDetails
          formData={formData}
          setFormData={setFormData}
          frontCover={frontCover}
          setFrontCover={setFrontCover}
          fileInputRef={fileInputRef}
        />
      </CustomTabPanel>

      {!isEditMode && (
        <CustomTabPanel value={value} index={1}>
          <AdmDesignComponent formData={formData} setFormData={setFormData} />
        </CustomTabPanel>
      )}

      <CustomTabPanel value={value} index={isEditMode ? 1 : 2}>
        <AdmPersonalDetails formData={formData} setFormData={setFormData} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={isEditMode ? 2 : 3}>
        <GuardianDetails formData={formData} setFormData={setFormData} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={isEditMode ? 3 : 4}>
        <AdmOtherDetails formData={formData} setFormData={setFormData} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={isEditMode ? 4 : 5}>
        <EmergencyContact formData={formData} setFormData={setFormData} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={isEditMode ? 5 : 6}>
        <AuthorisedPickUp formData={formData} setFormData={setFormData} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={isEditMode ? 6 : 7}>
        <DocumentsSubmitted formData={formData} setFormData={setFormData} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={isEditMode ? 7 : 8}>
        <PreviousEducationDetails
          formData={formData}
          setFormData={setFormData}
        />
      </CustomTabPanel>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <IconButton
          onClick={handlePrevious}
          disabled={value === 0}
          sx={{ mr: 1 }}
        >
          <ArrowBackIcon />{" "}
        </IconButton>
        {/* <IconButton
          onClick={handleNext}
          disabled={value === numberOfTabs - 1}
          sx={{ ml: 1 }}
        >
          <ArrowForwardIcon />{" "}
        </IconButton> */}
        <IconButton
          onClick={handleNext}
          disabled={value === maxTabIndex}
          sx={{ ml: 1 }}
        >
          <ArrowForwardIcon />
        </IconButton>
      </Box>

      {requiredFieldsAlert.isOpen && (
        <div
          className="modal show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              className="modal-content"
              style={{ borderRadius: "8px", overflow: "hidden" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  borderBottom: "none",
                }}
              >
                <h5 className="modal-title" style={{ fontWeight: 700 }}>
                  Missing Required Fields
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={closeRequiredFieldsAlert}
                />
              </div>

              <div className="modal-body" style={{ padding: "14px 18px 10px" }}>
                <p
                  className="text-center mb-3"
                  style={{ color: "#dc3545", fontWeight: 700 }}
                >
                  Please fill in the following required fields before {requiredFieldsAlert.actionText}:
                </p>
                <ul className="mb-0 ps-3">
                  {(requiredFieldsAlert.fields || []).length > 0 ? (
                    requiredFieldsAlert.fields.map((field) => (
                      <li key={field}>{field}</li>
                    ))
                  ) : (
                    <li>One or more required fields are missing.</li>
                  )}
                </ul>
              </div>

              <div className="modal-footer" style={{ borderTop: "none", paddingTop: 0 }}>
                <button
                  type="button"
                  className="btn"
                  style={{
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    minWidth: "110px",
                  }}
                  onClick={closeRequiredFieldsAlert}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Box>
  );
}
